import { isEmpty, last } from "lodash"
import moment from "moment"

const getters = {
  getLatestMessageId : ({ conversations, announcements }) => {
    let latestMessage = null
    
    if (!isEmpty(conversations)) {
      const chatRoom  = Object.values(conversations)[0]

      latestMessage = last(chatRoom.UnreadMessages) || last(chatRoom.Messages)
    } 
    
    if (!isEmpty(announcements)) {
      const chatRoom = Object.values(announcements).find(chatRoom => chatRoom.UnreadMessages.length || chatRoom.Messages.length)
      const announcement = chatRoom && (last(chatRoom.UnreadMessages) || last(chatRoom.Messages))

      if(announcement && latestMessage && moment(announcement.createdAt).isAfter(latestMessage.createdAt)){
        latestMessage = announcement
      }
    } 

    return latestMessage && latestMessage.id
  }
}

export default getters
